import {makeLogos} from '@adv-mt/mt-shared-make-logos'

import {STEPS} from '../settings.js'
import {handleError} from '../utils.js'

export const getInitialProps = async ({routeInfo, context: {domain, i18n}}) => {
  const {
    location: {state}
  } = routeInfo

  const config = domain.get('config')

  const {
    VEHICLE_SUGGESTER_PATH_PATTERN: homeSuggesterPath,
    VEHICLE_SUGGESTER_MAKES_PAGE_NAME: pageName,
    VEHICLE_SUGGESTER_RESULTS_PATH_PATTERN: nextPagePath,
    VEHICLE_SUGGESTER_SEATS_PATH_PATTERN: previousPagePath
  } = config.get('page')

  const [error, makesOptionsResponse] = await domain.get('get_configurator_makes_options_vehicles_use_case').execute({
    priceFrom: state?.priceRange?.from,
    priceTo: state?.priceRange?.to,
    bodyTypeIds: state?.bodyTypeIds,
    fuelTypeIds: state?.fuelTypeIds,
    seats: state?.seats?.value ?? []
  })
  if (error) {
    return handleError({
      domain,
      i18n,
      error,
      message: 'Error fetching makes options',
      redirectTo: homeSuggesterPath
    })
  }

  const makeOptions = makesOptionsResponse.getFilterOptions().map(option => ({
    ...option,
    icon: makeLogos[option.id]
  }))

  return {
    h1: i18n.t('COMMON.SUGGESTER'),
    nextPagePath,
    makeOptions,
    pageName,
    previousPagePath,
    step: STEPS.MAKES,
    stepBreadcrumb: i18n.t('COMMON.PLURALS.MAKE', 2),
    title: i18n.t('VEHICLE_SUGGESTER.STEP_MAKES.TITLE')
  }
}
